/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum InvestmentApprovalStatus {
    PENDING = 'PENDING',
    APPROVED = 'APPROVED',
}
